export default __webpack_public_path__ + "static/media/1.c01627b4.jpg";